import { LoadableLazy } from '@confluence/loadable';

export const RtPaidFeatureEducationComponentLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RtPaidFeatureEducationComponent" */ '../src/ui/RtPaidFeatureEducationComponent'
			)
		).RtPaidFeatureEducationComponent,
});
